// extracted by mini-css-extract-plugin
export var ctaAreaImg = "styles-module--cta-area-img--1xY0I";
export var ctaAreaWrapper = "styles-module--cta-area-wrapper--2bJxE";
export var inverted = "styles-module--inverted--NGwJs";
export var ctaAreaButton = "styles-module--cta-area-button--8FuwS";
export var ctaAreaBackdrop = "styles-module--cta-area-backdrop--3ZM3s";
export var withImage = "styles-module--with-image--ZVpQ7";